import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Stack,
  Box,
  Typography,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const TableView = ({ dataset = [], columns, rowClass }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  /* ========= スマホ表示 ========= */
  if (isMobile) {
    return (
      <Stack spacing={2}>
        {dataset.length === 0 ? (
          <Typography>データがありません</Typography>
        ) : (
          dataset.map((item, rowIndex) => (
            <Box
              key={item.id || item.product_id || rowIndex}
              sx={{
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 1,
                p: 2,
              }}
            >
              <Stack spacing={1}>
                {columns.map(
                  (column, columnIndex) =>
                    column.type !== "checkbox" && (
                      <Box
                        key={column.accessor || column.key || columnIndex}
                      >
                        <Typography
                          variant="caption"
                          color="text.secondary"
                        >
                          {column.label}
                        </Typography>

                        <Typography component="div">
                          {column.format
                            ? column.format(item[column.accessor], item)
                            : column.render
                              ? column.render(item, rowIndex)
                              : item[column.accessor] || "-"}
                        </Typography>
                      </Box>
                    )
                )}
              </Stack>
            </Box>
          ))
        )}
      </Stack>
    );
  }

  /* ========= PC表示 ========= */
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {columns.map(
            (column, columnIndex) =>
              column.type !== "checkbox" && (
                <TableCell
                  key={column.accessor || column.key || columnIndex}
                  sx={{
                    width: column.width,
                    minWidth: column.minWidth,
                  }}
                >
                  {column.label}
                </TableCell>
              )
          )}
        </TableRow>
      </TableHead>

      <TableBody>
        {dataset.length === 0 ? (
          <TableRow>
            <TableCell colSpan={columns.length}>
              データがありません
            </TableCell>
          </TableRow>
        ) : (
          dataset.map((item, rowIndex) => (
            <TableRow
              key={item.id || item.product_id || rowIndex}
              className={rowClass}
            >
              {columns.map(
                (column, columnIndex) =>
                  column.type !== "checkbox" && (
                    <TableCell
                      key={column.accessor || column.key || columnIndex}
                    >
                      {column.format
                        ? column.format(item[column.accessor], item)
                        : column.render
                          ? column.render(item, rowIndex)
                          : item[column.accessor] || "-"}
                    </TableCell>
                  )
              )}
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
};

export default TableView;